module.exports = __webpack_public_path__ + "img/Star_solid.5c64f4e5.svg";